import { types } from "../types/types";

/*
    {
        notes: [],
        active: { => or null
            id: '12g3f1gh2213',
            title: 'soy un titulo',
            body: ' descripcion',
            imageUrl: '',
            date: 1231231
        }
    }
*/

const initialState = {
    notes: [],
    active: null
}

export const notesReducer = ( state = initialState, action ) => {
    switch (action.type) {
        case types.notesActive:
            return {
                ...state,
                active: {
                    ...action.payload
                }
            }
        case types.notesLoad:
            return {
                ...state,
                notes: [ ...action.payload ]
            } 
        case types.notesUpdated:
            return {
                ...state,
                notes: state.notes.map( 
                    note => note.id === action.payload.id
                        ? action.payload.note
                        : note
                )
            }
        case types.notesDelete:
            return {
                ...state,
                active: null,
                notes: state.notes.filter( note => note.id !== action.payload )
            }
        case types.notesAddNew:
            return {
                ...state,
                notes: [ action.payload,...state.notes  ]
            }
        case types.notesLogoutCleaning:
            return {
                notes: [  ],
                active: null

            }
        default:
            return state;
    }
}

